ko.bindingHandlers.numericValue = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var underlyingObservable = valueAccessor();
        var interceptor = ko.dependentObservable({
            read: underlyingObservable,
            write: function (value) {
                if (!isNaN(value)) {
                    underlyingObservable(parseFloat(value));
                }
            }
        });
        ko.bindingHandlers.value.init(element, function () { return interceptor }, allBindingsAccessor);
    },
    update: ko.bindingHandlers.value.update
};


/** Binding for inline validation - jQuery Validation Plugin
*  http://bassistance.de/jquery-plugins/jquery-plugin-validation/
*/
ko.bindingHandlers.valueWithAutoValidation = {
    init: ko.bindingHandlers.value.init,
    update: function (element, valueAccessor, allBindingsAccessor) {
        ko.bindingHandlers.value.update.apply(this, arguments);
        $(element).valid();
        var form = $(element.form);
        form.trigger('invalid-form.validate', [form.data("validator")]);
    }
};

/** Binding for form validation - jQuery Validation Plugin
*  http://bassistance.de/jquery-plugins/jquery-plugin-validation/
*/
ko.bindingHandlers.jqValidate = {
    init: function (element, valueAccessor) {
        var options = valueAccessor();
        $(element).validate(options);
    }
};

ko.bindingHandlers.masked = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var mask = allBindingsAccessor().mask || {};
        var placeholder = allBindingsAccessor().placeholder;
        if (placeholder) {
            $(element).mask(mask, { placeholder: placeholder });
        } else {
            $(element).mask(mask);
        }
        ko.utils.registerEventHandler(element, "blur", function () {
            var observable = valueAccessor();
            observable($(element).val());
        });
    },
    update: function (element, valueAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor());
        $(element).val(value);
    }
};
  

/** Binding to make content appear with 'fade' effect */
ko.bindingHandlers['fadeIn'] = {
    'update': function (element, valueAccessor) {
        var options = valueAccessor();
        if (options() === true)
            $(element).fadeIn('slow');
    }
};
/** Binding to make content disappear with 'fade' effect */
ko.bindingHandlers['fadeOut'] = {
    'update': function (element, valueAccessor) {
        var options = valueAccessor();
        if (options() === true)
            $(element).fadeOut('slow');
    }
};

/** Binding for stylized buttons - jQuery UI Button Widget
*  http://jqueryui.com/demos/button/
*/
ko.bindingHandlers.jqButton = {
    init: function (element, valueAccessor) {
        var options = valueAccessor();
        $(element).button(options);
    }
};

/**
* Binding for jQuery Datatables
* http://datatables.net
*/
ko.bindingHandlers.dataTable = {
    init: function (element, valueAccessor) {
        var options = valueAccessor();
        var defaults = {
            "aaData": options["data"](),
            "bJQueryUI": true,
            "bFilter": true,
            "bAutoWidth": false,
            "bLengthChange": false,
            "bRetrieve": true,
            "bSortClasses": false,
            "fnRowCallback": function (nRow, aData, iDisplayIndex) {
                $(nRow).mouseover(function () {
                    $(nRow).attr("style", "background-color:yellow !important;");
                });
                $(nRow).mouseout(function () {
                    $(nRow).removeAttr("style");
                });
                if (typeof options["rowClick"] === "function") {
                    $(nRow).unbind('click').click(function () {
                        options["rowClick"](aData);
                    });
                }
                return nRow;
            },
            "oLanguage": TABLE_LANGUAGE
        }
        var tableOptions = $.extend(defaults, options["options"]);
        options["object"]($(element).dataTable(tableOptions).css("width", "99.5%"));
    },
    update: function (element, valueAccessor) {
        var options = valueAccessor();
        options["object"]().fnClearTable();
        options["object"]().fnAddData(options["data"](), true);
    }
};

/** Binding for stylized tabs - jQuery UI Tabs Widget
*  http://jqueryui.com/demos/tabs/
*/
ko.bindingHandlers.jqTabs = {
    init: function (element, valueAccessor) {
        var options = valueAccessor();
        $(element).tabs(ko.utils.unwrapObservable(options));
    },
    update: function (element, valueAccessor) {
        var options = valueAccessor();
        $(element).tabs('option', ko.utils.unwrapObservable(options));
    }
};

/** Binding for strict MVVM use, associating an observable with the jQuery object of the element */
ko.bindingHandlers.jqElement = {
    init: function (element, valueAccessor) {
        var options = valueAccessor();
        options($(element));
    }
}

/** Binding for accordion widget - jQuery UI Accordion Widget
*  http://jqueryui.com/demos/accordion/
*/
ko.bindingHandlers.jqAccordion = {
    init: function (element, valueAccessor) {
        var options = valueAccessor();
        var jqElement = $(element);
        jqElement.accordion(options);
        jqElement.bind("valueChanged", function () {
            ko.bindingHandlers.jqAccordion.update(element, valueAccessor);
        });
    },
    update: function (element, valueAccessor) {
        var options = valueAccessor();
        $(element).accordion('destroy').accordion(options);
    }
};

/** Binding for adding stylized and rich multiselect - jQuery UI MultiSelect Widget
*  http://www.erichynds.com/jquery/jquery-ui-multiselect-widget/
*/
ko.bindingHandlers.jqMultiSelect = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var defaults = {
            click: function (event, ui) {
                var selected_options = $.map($(element).multiselect("getChecked"), function (a) { return $(a).val() });
                allBindingsAccessor()['selectedOptions'](selected_options);
            }
        };
        var options = $.extend(defaults, valueAccessor());
        allBindingsAccessor()['options'].subscribe(function (value) {
            ko.bindingHandlers.jqMultiSelect.regenerateMultiselect(element, options, viewModel);
        });
        allBindingsAccessor()['selectedOptions'].subscribe(function (value) {
            ko.bindingHandlers.jqMultiSelect.regenerateMultiselect(element, options, viewModel);
        });
    },
    regenerateMultiselect: function (element, options, viewModel) {
        if ($(element).next().hasClass("ui-multiselect")) {
            setTimeout(function () {
                return $(element).multiselect("refresh").multiselectfilter({
                    label: options['filterLabel'] || "Search: "
                }); ;
            }, 0);
        } else {
            setTimeout(function () {
                if (options['filter'] === true) {
                    $(element).multiselect(options).multiselectfilter({
                        label: options['filterLabel'] || "Search: "
                    });
                } else {
                    $(element).multiselect(options);
                }
                if (options['noChecks'] === true) {
                    $(element).next().next().find(".ui-helper-reset:first").remove();
                }
            }, 0);
        }
    }
};

/** Binding for window dialogs - jQuery UI Dialog Widget
*  http://jqueryui.com/demos/dialog/
*/
ko.bindingHandlers.jqDialog = {
    init: function (element, valueAccessor) {
        var defaults = {
            modal: true,
            autoOpen: false,
            closeOnEscape: false
        }
        var options = $.extend(defaults, valueAccessor());
        $(element).dialog(options);
    }
};

/** jqueryui datepicker
*   http://stackoverflow.com/questions/6612705/jquery-ui-datepicker-change-event-not-caught-by-knockoutjs
*/
ko.bindingHandlers.datepicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        //initialize datepicker with some optional options
        var options = allBindingsAccessor().datepickerOptions || {},
            $el = $(element);

        $el.datepicker(options);

        //handle the field changing
        ko.utils.registerEventHandler(element, "change", function () {
            var observable = valueAccessor();
            observable($el.datepicker("getDate"));
        });

        //handle disposal (if KO removes by the template binding)
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $el.datepicker("destroy");
        });

    },
    update: function (element, valueAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor()),
            $el = $(element);

        //handle date data coming via json from Microsoft
        if (String(value).indexOf('/Date(') == 0) {
            value = new Date(parseInt(value.replace(/\/Date\((.*?)\)\//gi, "$1")));
        }

        var current = $el.datepicker("getDate");

        if (value - current !== 0) {
            $el.datepicker("setDate", value);
        }
    }
};

ko.bindingHandlers.enterkey = {
    init: function (element, valueAccessor, allBindings, viewModel) {
        var callback = valueAccessor();
        $(element).keypress(function (event) {
            var keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                callback.call(viewModel);
                return false;
            }
            return true;
        });
    }
};

/** Binding for delayed value update - only fired if user does not hit any key for 300ms.
*  
*/
ko.bindingHandlers.debounceValue = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var currel = element;
        var underlyingObservable = valueAccessor();
        var interceptor = ko.pureComputed({
            read: underlyingObservable,
            write: function (value) {
                clearTimeout(interceptor.timerHandle);
                interceptor.timerHandle = setTimeout(function () {
                    var oldval = underlyingObservable();
                    var currval = currel.value;
                    if (oldval != value && oldval != currval) {
                        underlyingObservable(currval);//currval is the very current value of the input element.
                        //if (console)
                        //    console.log('oldval: ' + oldval + '; currval: ' + currval + '; value: ' + value);
                    }
                }, 300);
            }
        });
        ko.bindingHandlers.value.init(element, function () { return interceptor }, allBindingsAccessor);
    },
    update: ko.bindingHandlers.value.update
};
